
import { application } from "./application";

// Auto-imported local controllers
import Controller0 from "./ace_editor_controller.js";
import Controller1 from "./active_link_controller.js";
import Controller2 from "./add_on_kind_controller.js";
import Controller3 from "./autofocus_controller.js";
import Controller4 from "./background_source_controller.js";
import Controller5 from "./bundle_toggle_controller.js";
import Controller6 from "./calendar_dropdown_controller.js";
import Controller7 from "./checkbox_observer_controller.js";
import Controller8 from "./checkbox_select_all_controller.js";
import Controller9 from "./choices_controller.js";
import Controller10 from "./choose_or_create_controller.js";
import Controller11 from "./click_controller.js";
import Controller12 from "./clipboard_controller.js";
import Controller13 from "./cmd_enter_controller.js";
import Controller14 from "./color_field_controller.js";
import Controller15 from "./color_scheme_controller.js";
import Controller16 from "./coloris_setup_controller.js";
import Controller17 from "./composer_tabs_controller.js";
import Controller18 from "./contrast_badge_controller.js";
import Controller19 from "./create_event_controller.js";
import Controller20 from "./cropper_controller.js";
import Controller21 from "./current_item_controller.js";
import Controller22 from "./custom_field_form_controller.js";
import Controller23 from "./custom_metadata_validation_controller.js";
import Controller24 from "./custom_text_inspector_controller.js";
import Controller25 from "./default_to_placeholder_controller.js";
import Controller26 from "./dependent_checkboxes_controller.js";
import Controller27 from "./disable_click_controller.js";
import Controller28 from "./disable_other_element_controller.js";
import Controller29 from "./docs_api_token_controller.js";
import Controller30 from "./docs_code_tabs_controller.js";
import Controller31 from "./docs_nav_controller.js";
import Controller32 from "./docs_search_controller.js";
import Controller33 from "./docs_tooltip_controller.js";
import Controller34 from "./draft_controller.js";
import Controller35 from "./dynamic_turbo_frame_controller.js";
import Controller36 from "./edit_venue_controller.js";
import Controller37 from "./event_preview_controller.js";
import Controller38 from "./example_promotion_codes_controller.js";
import Controller39 from "./flash_controller.js";
import Controller40 from "./html_template_form_controller.js";
import Controller41 from "./inactive_overlay_controller.js";
import Controller42 from "./inspector_color_field_controller.js";
import Controller43 from "./inspector_tabs_controller.js";
import Controller44 from "./integration_field_mapping_controller.js";
import Controller45 from "./modal_controller.js";
import Controller46 from "./nested_form_controller.js";
import Controller47 from "./new_data_indicator_controller.js";
import Controller48 from "./offer_interval_controller.js";
import Controller49 from "./open_modal_controller.js";
import Controller50 from "./palette_color_controller.js";
import Controller51 from "./password_strength_controller.js";
import Controller52 from "./placeholder_override_controller.js";
import Controller53 from "./places_autocomplete_controller.js";
import Controller54 from "./poll_refresh_controller.js";
import Controller55 from "./popover_hint_controller.js";
import Controller56 from "./preserve_ids_in_url_controller.js";
import Controller57 from "./price_and_tax_controller.js";
import Controller58 from "./radius_buttons_controller.js";
import Controller59 from "./remote_modal_controller.js";
import Controller60 from "./reset_to_default_controller.js";
import Controller61 from "./reveal_controller.js";
import Controller62 from "./reveal_invalid_controller.js";
import Controller63 from "./scroll_to_selected_controller.js";
import Controller64 from "./search_form_controller.js";
import Controller65 from "./slug_controller.js";
import Controller66 from "./sms_counter_controller.js";
import Controller67 from "./sortable_controller.js";
import Controller68 from "./status_controller.js";
import Controller69 from "./sync_inputs_controller.js";
import Controller70 from "./tablist_controller.js";
import Controller71 from "./tax_rate_attachment_controller.js";
import Controller72 from "./templates_nav_link_controller.js";
import Controller73 from "./textarea_autogrow_controller.js";
import Controller74 from "./textarea_suggest_controller.js";
import Controller75 from "./time_controller.js";
import Controller76 from "./time_dropdown_controller.js";
import Controller77 from "./tiptap_controller.js";
import Controller78 from "./tooltip_controller.js";
import Controller79 from "./typeface_warning_controller.js";
import Controller80 from "./uppy_controller.js";
import Controller81 from "./venue_field_controller.js";
import Controller82 from "./web_authn_controller.js";
import Controller83 from "./widget_form_controller.js";

application.register("ace-editor", Controller0);
application.register("active-link", Controller1);
application.register("add-on-kind", Controller2);
application.register("autofocus", Controller3);
application.register("background-source", Controller4);
application.register("bundle-toggle", Controller5);
application.register("calendar-dropdown", Controller6);
application.register("checkbox-observer", Controller7);
application.register("checkbox-select-all", Controller8);
application.register("choices", Controller9);
application.register("choose-or-create", Controller10);
application.register("click", Controller11);
application.register("clipboard", Controller12);
application.register("cmd-enter", Controller13);
application.register("color-field", Controller14);
application.register("color-scheme", Controller15);
application.register("coloris-setup", Controller16);
application.register("composer-tabs", Controller17);
application.register("contrast-badge", Controller18);
application.register("create-event", Controller19);
application.register("cropper", Controller20);
application.register("current-item", Controller21);
application.register("custom-field-form", Controller22);
application.register("custom-metadata-validation", Controller23);
application.register("custom-text-inspector", Controller24);
application.register("default-to-placeholder", Controller25);
application.register("dependent-checkboxes", Controller26);
application.register("disable-click", Controller27);
application.register("disable-other-element", Controller28);
application.register("docs-api-token", Controller29);
application.register("docs-code-tabs", Controller30);
application.register("docs-nav", Controller31);
application.register("docs-search", Controller32);
application.register("docs-tooltip", Controller33);
application.register("draft", Controller34);
application.register("dynamic-turbo-frame", Controller35);
application.register("edit-venue", Controller36);
application.register("event-preview", Controller37);
application.register("example-promotion-codes", Controller38);
application.register("flash", Controller39);
application.register("html-template-form", Controller40);
application.register("inactive-overlay", Controller41);
application.register("inspector-color-field", Controller42);
application.register("inspector-tabs", Controller43);
application.register("integration-field-mapping", Controller44);
application.register("modal", Controller45);
application.register("nested-form", Controller46);
application.register("new-data-indicator", Controller47);
application.register("offer-interval", Controller48);
application.register("open-modal", Controller49);
application.register("palette-color", Controller50);
application.register("password-strength", Controller51);
application.register("placeholder-override", Controller52);
application.register("places-autocomplete", Controller53);
application.register("poll-refresh", Controller54);
application.register("popover-hint", Controller55);
application.register("preserve-ids-in-url", Controller56);
application.register("price-and-tax", Controller57);
application.register("radius-buttons", Controller58);
application.register("remote-modal", Controller59);
application.register("reset-to-default", Controller60);
application.register("reveal", Controller61);
application.register("reveal-invalid", Controller62);
application.register("scroll-to-selected", Controller63);
application.register("search-form", Controller64);
application.register("slug", Controller65);
application.register("sms-counter", Controller66);
application.register("sortable", Controller67);
application.register("status", Controller68);
application.register("sync-inputs", Controller69);
application.register("tablist", Controller70);
application.register("tax-rate-attachment", Controller71);
application.register("templates-nav-link", Controller72);
application.register("textarea-autogrow", Controller73);
application.register("textarea-suggest", Controller74);
application.register("time", Controller75);
application.register("time-dropdown", Controller76);
application.register("tiptap", Controller77);
application.register("tooltip", Controller78);
application.register("typeface-warning", Controller79);
application.register("uppy", Controller80);
application.register("venue-field", Controller81);
application.register("web-authn", Controller82);
application.register("widget-form", Controller83);
